// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { BoosterButtonLayout } from './BoosterButtonLayout';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: '74df65c7-cd74-46ca-8007-67acbf9f0b1e',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * -0.5'
        }
      }
    },
    {
      id: 'c16d4f18-2991-4730-82ec-b112d464fd66',
      type: 'Sprite',
      name: 'bg',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Wood_Background',
      parent: '74df65c7-cd74-46ca-8007-67acbf9f0b1e',
      data: {
        dynamicValues: {
          width: 'width',
          height: 'height'
        }
      }
    },
    {
      id: '62d6e365-b455-4a12-914d-7178f17ce299',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '2_Booster_Unlocked',
      parent: '74df65c7-cd74-46ca-8007-67acbf9f0b1e',
      data: {
        DEBUG: true
      }
    },
    {
      id: '122b098b-8ceb-482e-8273-61ccbcca945e',
      type: 'Container',
      name: 'contentContainer',
      className: '',
      x: 0,
      y: 640,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74df65c7-cd74-46ca-8007-67acbf9f0b1e'
    },
    {
      id: 'd6576665-25fc-469e-83c4-bacf8ebd38a6',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: -127,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16160560,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '1035a9cb-2e57-4b6c-a148-82b443a2b176',
      type: 'Text',
      name: 'header',
      className: 'colorTags_SPL',
      x: 0,
      y: -449,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Hammer Booster <br> $Unlocked$!',
      localize: false,
      maxWidth: 660,
      maxHeight: 300,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 70,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e',
      data: {
        colorTags: {
          $: '#FFC635'
        }
      },
      stateByName: {
        collect: {
          text: 'Booster $Reward!$',
          localize: true
        }
      }
    },
    {
      id: 'c37c9266-dca6-4014-9bed-6a5efd288543',
      type: 'Text',
      name: 'description',
      className: 'colorTags_SPL',
      x: 0,
      y: 175,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$Target a stack$ with the Hammer to $collect it$!',
      localize: false,
      maxWidth: 630,
      maxHeight: 230,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 630,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e',
      data: {
        colorTags: {
          $: '#34DAFA'
        }
      }
    },
    {
      id: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      type: 'Container',
      name: 'actionButton',
      className: '',
      x: 0,
      y: 444,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e'
    },
    {
      id: '9864e86f-4351-474a-b5fb-5a7ef9659fec',
      type: 'Layout',
      name: 'boosterIcon',
      className: '',
      path: 'boosters/BoosterButtonLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: -127,
      scale: {
        x: 2.4,
        y: 2.4
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '122b098b-8ceb-482e-8273-61ccbcca945e',
      data: {
        applyProps: {
          indicator: {
            visible: false
          },
          attractOverlay: {
            visible: false
          }
        }
      }
    },
    {
      id: 'afc836ec-c919-4da3-a4c3-026583d4bac4',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      skin: '',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1.03,
        y: 1.11
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '6fe9984d-a134-439d-8269-09e9b7b636a6',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Try for Free!',
      localize: true,
      maxWidth: 414,
      maxHeight: 154,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 58,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1F5316',
        strokeThickness: 8,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'e8ec1faa-2bd4-494c-b2f6-38235b63ef8d',
      stateByName: {
        collect: {
          text: 'Collect',
          localize: true
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'collect'
  ],
  handleResize: false
} as const;

export class BoosterTryPopupLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  bg!: Sprite & { data: typeof raw['list'][1]['data'] };
  contentContainer!: Container;
  rays!: Sprite;
  header!: Text & { data: typeof raw['list'][5]['data'] };
  description!: Text & { data: typeof raw['list'][6]['data'] };
  actionButton!: Container;
  boosterIcon!: BoosterButtonLayout & { data: typeof raw['list'][8]['data'] };
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] })[];
  rotate_SPL!: (Sprite)[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][5]['data'] } | Text & { data: typeof raw['list'][6]['data'] })[];
  StateName!: 'collect';

  constructor() {
    populate(this, raw);
  }
}
